export default __webpack_public_path__ + "static/media/user-avatar4-new.e9501368.png";